<script setup lang="ts">
import { ArrowRight } from 'lucide-vue-next'

defineProps<{
  id: string | number | Record<string, number | string>
  name?: string
  pathName: string
}>()
</script>

<template>
  <RouterLink
    :to="{
      name: pathName,
      params: typeof id === 'object' ? id : { id },
    }"
    @click.stop.prevent
  >
    <div class="hover:bg-slate-200 group p-2 rounded-sm">
      <ArrowRight class="group-hover:translate-x-1 transition-all" :size="16" />
    </div>
  </RouterLink>
</template>
